import styled from 'styled-components';

export const Container = styled.div`
  padding: 1rem 2rem;
  width: 100%;

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray600};
  }
  h1 {
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.gray600};
    margin-bottom: -1.3rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  h1 {
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.gray600};
  }
`;

export const Hr = styled.div<{ notMargin?: boolean; small?: boolean }>`
  /* height: ${({ small }) => (small ? '1px' : '2px')};
  background-color: ${({ theme }) => theme.colors.gray200}; */
  margin: ${({ notMargin }) => !notMargin && '1rem -2rem 1rem -2rem'};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  margin-inline: 0.1rem;
`;

export const LawyerBox = styled.div`
  border-radius: 4px;
  padding: 0.8rem 1.3rem;
  background-color: ${({ theme }) => theme.colors.white100};
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.black700};
  font-weight: 500;
  font-size: 16px;
  width: 100%;
`;

export const ParagraphItalic = styled.p`
  color: ${({ theme }) => theme.colors.black700};
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
`;
export const LawyerBoxContent = styled.p`
  color: ${({ theme }) => theme.colors.gray400};
  font-weight: 700;
  font-size: 14px;
  /* width: 100%; */
`;
export const HistoryContent = styled.p`
  color: ${({ theme }) => theme.colors.gray600};
  font-weight: 500;
  font-size: 16px;
`;
